import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user.js'
import vredit from './modules/vredit.js'
import siteConfig from './modules/siteConfig.js'
import permission from './modules/permission.js'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
	// strict: true,
	plugins: [
		// localStorage
		// createPersistedState({
		// 	storage: window.localStorage,
		// 	reducer: state => {
		// 		return {
		// 			setting: state.setting
		// 		}
		// 	}
		// }),
		// sessionStorage
		createPersistedState({
			storage: window.localStorage,
			reducer: state => {
				return {
					user: { token: state.user.token, wxUserInfo: state.user.wxUserInfo },
				}
			}
		})
	],
	modules: {
		user,
		vredit,
		siteConfig,
		permission,
	},
	getters
})

export default store